export default function SmartFeatures() {
  const features = [
    {
      icon: 'ri-temp-cold-line',
      title: 'Climate Intelligence',
      description: 'Advanced HVAC system with AI-powered temperature regulation adapts to weather conditions and occupancy patterns for optimal comfort year-round.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Adaptive Lighting',
      description: 'Circadian rhythm lighting system automatically adjusts color temperature and brightness throughout the day to enhance wellbeing and sleep quality.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Energy Optimisation',
      description: 'Solar-ready electrical system with smart energy management for energy-conscious operation.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Voice & App Control',
      description: 'Complete IoT integration allows remote monitoring and control of all systems through intuitive mobile app or voice commands.',
    },
  ];

  return (
    <section id="features" className="relative py-32 px-8">
      {/* Blueprint background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(0,217,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(0,217,255,0.3) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="text-xs text-cyan-400 uppercase tracking-widest mb-4">INTELLIGENT SYSTEMS</div>
          <h2 className="text-5xl font-thin tracking-wide">Technology That Adapts to You</h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-[#14141e]/60 to-[#0a0a0f]/60 backdrop-blur-xl border border-cyan-500/30 rounded-lg p-10 hover:border-cyan-400/60 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,217,255,0.2)] hover:-translate-y-2 cursor-pointer"
            >
              <div className="border-t-2 border-cyan-500 absolute top-0 left-0 w-16"></div>
              
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-5xl text-cyan-400 group-hover:animate-pulse`} style={{ textShadow: '0 0 20px rgba(0,217,255,0.6)' }}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-medium mb-4 text-white">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed mb-6">{feature.description}</p>

              {/* Learn More Link */}
              <div className="flex items-center gap-2 text-sm text-gray-500 group-hover:text-cyan-400 transition-colors">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}